import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { LoteService } from 'src/app/core/services/lote.service';
import { TableAction } from 'src/app/shared/components/table-paginator/table-paginator.component';
import { Router } from '@angular/router';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { DownloadService } from 'src/app/core/services/download.service';
import { LoteCertificadoService } from 'src/app/core/services/lote-certificado.service';
import { LoteCertificado } from 'src/app/models/LoteCertificado.model';
import { FirmaUtils } from 'src/app/core/utils/firma.utils';
import * as JSZip from 'jszip';
import { PermisosModalComponent } from 'src/app/shared/components/permisos-acceso/permisos-modal.component';
import { AuthService } from 'src/app/core/services/AuthService';


interface Item {
    id?: string;
    titulo: string;
    notificacion_firmantes: string;
    firma_simple: boolean;
    estado: string;
    id_estado: number;
    fecha_creacion: string;
    id_servicio_externo: string,
    id_usuario_creacion: string
}

@Component({
    selector: 'app-adminlote-component',
    templateUrl: './admin-lote.component.html',
    styleUrls: ['./admin-lote.css'],
})
export class AdminLoteComponent implements OnInit {
    @ViewChild('participantesContent') participantesContent: TemplateRef<any>;
    fullData: Item[] = []; // Tu conjunto completo de datos

    currentItems: Item[] = []; // Los datos para la página actual
    currentPage: number = 1;
    pageSize: number = 10; // Tamaño de página inicial
    totalItems: number = 0;
    spinner: boolean;
    public isDiviceType: boolean = false;
    loteCertificado: LoteCertificado[];
    loteCompartido: boolean = false;
    currentUser:any = null;

    tableHeaders = [
        //{ key: 'id', label: 'ID' },
        { key: 'titulo', label: 'Titulo' },
        { key: 'notificacion_firmantes', label: 'Notificar Firmantes' },
        { key: 'tipo_firma' , label: 'Tipo' } , 
        { key: 'es_grupo', label: 'Es Grupo' },
        { key: 'fecha_creacion', label: 'Fecha Creación' },
        { key: 'estado', label: 'Estado sobre' }
    ];

    customActions: TableAction[] = [];
    searchForm!: FormGroup;

    // Toast
    toast = Swal;
    firmaUtils = FirmaUtils;


    constructor(
        private loteService: LoteService,
        private router: Router,
        private downloadService: DownloadService,
        private modalService: NgbModal,
        private loteCertificadoService: LoteCertificadoService,
        private fb: FormBuilder , 
        private authService: AuthService
    ) {
        this.searchForm = this.fb.group({
            search: ['']
        });

    }


    ngOnInit() {
        this.toastAlert();
        this.getLotes();
        this.checkDeviceType();
        this.currentUser = this.authService.currentUserValue;                

        this.customActions = [
            {
                label: 'Editar.',
                handler: (item: Item) => this.showLote(item.id, item.firma_simple, item.id_servicio_externo),
                icon: 'fa-solid fa-pen-to-square',
                colorClass: 'bg-orange',
                visible: (item: Item) => item.id_estado != 3 && this.loteCompartido == false
            },
            {
                label: 'Descargar.',
                handler: (item: Item) => this.descargarDocumento(item.id, item.titulo),
                icon: 'fa-solid fa-download',
                colorClass: 'bg-green',
                visible: (item: Item) => item.id_estado == 3
            },
            {
                label: 'Compartir.',
                handler: (item: Item) => { void this.compartirPdf(item.titulo, parseInt(item.id)) },
                icon: 'fa-solid fa-share-nodes',
                colorClass: 'bg-yellow',
                visible: (item: Item) => item.id_estado == 3 && this.isDiviceType
            },
            {
                label: 'Participantes.',
                handler: (item: Item) => this.showCertificadoModal(parseInt(item.id)),
                icon: 'fa-solid fa-users-gear',
                colorClass: 'bg-blue'
            },
            // {
            //     label: 'Reintentar firma.',
            //     handler: (item: Item) => this.eliminarLote(parseInt(item.id)),
            //     icon: 'fa-solid fa-arrows-rotate',
            //     colorClass: 'bg-yellow',
            //     visible: (item: Item) => item.id_estado != 3
            // },
            {
                label: 'Eliminar Sobre',
                handler: (item: Item) => this.eliminarLote(parseInt(item.id)),
                icon: 'fa-solid fa-trash',
                colorClass: 'bg-red',
                visible: (item: Item) =>  item.id_estado != 3 && this.loteCompartido == false && this.currentUser?.id == item?.id_usuario_creacion 
            },
            {
                label: 'Gestionar Acceso',
                handler: (item: Item) => this.gestionarAcceso(item.id),
                icon: 'fa-solid fa-lock',
                colorClass: 'bg-blue',
            },
               {
                label: 'Reintentar envio' , 
                handler:(item: Item) => this.reintentarEnvio(item.id),
                icon: 'fa-solid fa-retweet',
                colorClass: 'bg-blue',
                visible: (item: Item) => (item.id_estado == 3  &&  !!item.id_servicio_externo                    
                )
            }

        ];
    }


    async reintentarEnvio(id: any){
        Swal.fire({
            title: "¿Deseas retransmitir este sobre?",
            text: "Este sobre se volverá a retransmitir al servicio externo",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Reenviar",
            cancelButtonText: "Cancelar",
        }).then(async (result) => {
            if (result.isConfirmed) {                
                let response = await  lastValueFrom(this.loteService.retransmitirServicioExterno(id));
                                              
            }
        });

    }

    async gestionarAcceso(id: any) {
        const modalRef = this.modalService.open(PermisosModalComponent, {
          centered: true,
          size: 'xl',
        });
        modalRef.componentInstance.id = id;
        modalRef.componentInstance.modeloAcceso = 'Lote';
        modalRef.componentInstance.notificar = true;
    }

    cambiarTab(esCompartido: boolean) {
        this.loteCompartido = esCompartido;
        this.currentPage = 1; // Reiniciamos a la primera página
        
        this.buscarLote(); 
    }

    async getLotes(search: string = '') {
        this.spinner = true;
        let params = new HttpParams();
        params = params.set('page', this.currentPage).set('limit', this.pageSize).set('pagination', true).set('titulo', search).set('compartido', this.loteCompartido);
        const result = await lastValueFrom(this.loteService.get<any[]>({ params }));
        this.spinner = false;
        const headers: HttpHeaders = result.headers;
        this.currentItems = result.body.map((x: any, index: number) => {            

            let tipoFirma = this.firmaUtils.getTipoFirma(x.firma_simple, x.id_servicio_externo, x.es_grupo, x.firma_por_plantilla);
                     
            return {
                id: x.id, titulo: (x.titulo),
                notificacion_firmantes: (x.notificacion_firmantes == true ? 'Si' : 'No'),
                es_grupo: (x.es_grupo == true ? 'Si' : 'No'),
                estado: x.estado.nombre,
                id_estado: x.estado.id,
                firma_simple: x.firma_simple,
                clase: x.estado.clase,
                fecha_creacion: this.formatFechaLocalSinUTC(x.createdAt),
                id_servicio_externo: x.id_servicio_externo , 
                id_usuario_creacion: x.usuario.id , 
                tipo_firma:  tipoFirma
            }
        });


        this.totalItems = Number(headers.get('X-Total-Count'));
    }

    buscarLote() {
        this.currentPage = 1;
        const texto = this.searchForm.value.search?.trim();

        if (!texto) {
            this.getLotes(); // o resetear resultados
            return;
        }

        // 🔥 aquí conectas tu servicio
        this.getLotes(texto);
    }


    async CreaLote() {
        this.router.navigate(['firmas/firma']);
    }

    async CreaLoteExterno(){
        this.router.navigate(['firmas/firma-externa']);
    }


    async showLote(id: any, tipoFirma: boolean, id_servicio_externo: string) {
        
        if (tipoFirma) {
            this.router.navigateByUrl('firmas/admin-simple/' + id);
        } else {
            if(!tipoFirma && id_servicio_externo != null){
                this.router.navigateByUrl('firmas/firma-externa/' + id);
            }else{
                this.router.navigateByUrl('firmas/' + id);
            }
            
        }

    }

    async showCertificadoModal(id: number) {
        const response = await lastValueFrom(this.loteCertificadoService.indexLoteCertificado(id));
        this.loteCertificado = (response as any).body as LoteCertificado[];
        this.modalService.open(this.participantesContent, {
            size: 'lg',
            centered: true
        });

    }
    
    async descargarZipPorLote(id: any, nameZip: string) {

        this.downloadService
            .descargarZipPorLote(id, 'mis_documentos')
            .subscribe((blob: Blob) => {
                const fileName = `${nameZip}.zip`; // o el que quieras
                const a = document.createElement('a');
                const objectUrl = URL.createObjectURL(blob);
                a.href = objectUrl;
                a.download = fileName;
                a.click();
                URL.revokeObjectURL(objectUrl);
            });
    }



    async descargarDocumento(id: any, nameZip: string): Promise<void> {
        try {

            const blob = await firstValueFrom(
                this.downloadService.descargarZipPorLote(
                    id,
                    nameZip
                )
            );

            const zip = await JSZip.loadAsync(blob);

            const entries = Object.keys(zip.files).filter(
                filename => !zip.files[filename].dir
            );

            // Más de un archivo -> descargar ZIP
            if (entries.length > 1) {
                const url = URL.createObjectURL(blob);

                const a = document.createElement('a');
                a.href = url;
                a.download = `${nameZip}.zip`;
                a.click();

                URL.revokeObjectURL(url);
                return;
            }

            // Un solo archivo -> extraer y descargar PDF
            const archivo = zip.files[entries[0]];
            const pdfBlob = await archivo.async('blob');

            const pdfUrl = URL.createObjectURL(pdfBlob);

            const a = document.createElement('a');
            a.href = pdfUrl;
            a.download = entries[0]; // conserva el nombre original
            a.click();

            URL.revokeObjectURL(pdfUrl);

        } catch (error) {
            
            this.alert('error', 'Error al descargar el documento');
        }
    }

    async compartirPdf(nameZip: string, id: any) {
        try {
            const blob = await firstValueFrom(this.downloadService.descargarZipPorLote(id, 'mis_documentos'));
            const files = await this.extraerZip(blob);

            if (files.length === 0) return;

            const nav = navigator as any;

            // IMPORTANTE: Algunos navegadores fallan si el array es muy grande
            // Intenta primero con el primer archivo para probar si es un tema de cantidad
            const dataToShare = {
                title: 'Documentos',
                text: 'Te comparto los documentos',
                files: files // Asegúrate de que sea el array de objetos File
            };

            if (nav.canShare && nav.canShare(dataToShare)) {
                await nav.share(dataToShare);
            } else {
                console.warn("El navegador no permite compartir estos archivos específicos.");
                this.descargarZipPorLote(id, nameZip);
            }
        } catch (error) {
            console.error("Error al compartir:", error);
            this.descargarZipPorLote(id, nameZip);
        }
    }

    async extraerZip(blob: Blob): Promise<File[]> {
        const MAX_FILES = 200;
        const MAX_ZIP_SIZE = 300 * 1024 * 1024; // 300 MB
        const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25 MB por PDF
        const MAX_TOTAL_SIZE = 1000 * 1024 * 1024; // 1 GB total

        if (blob.size > MAX_ZIP_SIZE) {
            this.alert('error', 'El archivo ZIP excede el tamaño máximo permitido');
            return [];
        }

        const zip = await JSZip.loadAsync(blob);
        const archivos: File[] = [];

        const entries = Object.keys(zip.files).filter(
            filename => !zip.files[filename].dir
        );

        if (entries.length > MAX_FILES) {
            this.alert('error', 'El ZIP no puede contener más de 200 documentos');
            return [];
        }

        let totalSize = 0;

        for (const filename of entries) {
            const zipEntry = zip.files[filename];

            if (
                filename.includes('..') ||
                filename.startsWith('/') ||
                filename.startsWith('\\')
            ) {
                this.alert('error', 'El ZIP contiene rutas no permitidas');
                return [];
            }

            const simpleName =
                filename.split('/').pop()?.split('\\').pop() || filename;

            if (!simpleName.toLowerCase().endsWith('.pdf')) {
                this.alert('error', 'El ZIP solo puede contener documentos PDF');
                return [];
            }

            const content = await zipEntry.async('blob');

            totalSize += content.size;

            if (content.size > MAX_FILE_SIZE) {
                this.alert('error', `El archivo ${simpleName} excede el tamaño permitido`);
                return [];
            }

            if (totalSize > MAX_TOTAL_SIZE) {
                this.alert('error', 'El contenido total del ZIP excede el tamaño permitido');
                return [];
            }

            const file = new File([content], simpleName, {
                type: 'application/pdf'
            });

            archivos.push(file);
        }

        return archivos;
    }

    async eliminarLote(id: number) {

        Swal.fire({
            title: "¡Eliminación de sobre!",
            text: "Deseas eliminar este sobre",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar",
        }).then(async (result) => {
            if (result.isConfirmed) {

                await lastValueFrom(this.loteService.deleteLote(id));
                await this.getLotes();
                this.alert('success', 'Sobre eliminado correctamente');
            }
        });

    }

    onPageChange(newPage: number): void {
        this.currentPage = newPage;
        this.getLotes();
    }

    onPageSizeChange(newSize: number): void {
        this.pageSize = newSize;
        this.currentPage = 1; // Siempre vuelve a la primera página al cambiar el tamaño
        this.getLotes();
    }

    toastAlert() {
        this.toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            }
        });
    }

    alert(icontext: SweetAlertIcon, title: string, text: string = '') {
        this.toast.fire({
            icon: icontext,
            title: title,
            text: text
        });
    }

    formatFechaLocalSinUTC(iso: string): string {
        // Quitamos la Z y los milisegundos
        const limpia = iso.replace('Z', '').split('.')[0];

        const d = new Date(limpia);

        const pad = (n: number) => n.toString().padStart(2, '0');

        return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} `
            + `${pad(d.getHours())}:${pad(d.getMinutes())}`;
    }

    private checkDeviceType() {

        const mobile = this.isMobile();
        const tablet = this.isTablet();

        this.isDiviceType = mobile || tablet;
    }

    isTablet(): boolean {

        const userAgent = navigator.userAgent.toLowerCase();

        const isIpad =
            /ipad/.test(userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

        const isAndroidTablet =
            /android/.test(userAgent) && !/mobile/.test(userAgent);

        return isIpad || isAndroidTablet;
    }

    isMobile(): boolean {

        const userAgent = navigator.userAgent.toLowerCase();

        return /iphone|ipod|android.*mobile|windows phone/i.test(userAgent);
    }

    isDesktop(): boolean {

        const hasMouse = window.matchMedia('(pointer:fine)').matches;

        return hasMouse && !this.isMobile() && !this.isTablet();
    }

}
